import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { AccountProfileComponent } from './components/account-profile/account-profile.component';
import { CommunityHeaderComponent } from './components/community-header/community-header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LayoutComponent } from './components/layout/layout.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { MenuComponent } from './components/menu/menu.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { ContentCreatorCardComponent } from './components/content-creator-card/content-creator-card.component';

const COMPONENTS = [
	AccountProfileComponent,
	CommunityHeaderComponent,
	ContentCreatorCardComponent,
	FooterComponent,
	HeaderComponent,
	LayoutComponent,
	MainLayoutComponent,
	MenuComponent,
	MobileMenuComponent,
]

@NgModule({
	declarations: [

	],
	imports: [
		CommonModule,
		RouterModule,
		SharedModule,
		NgbDropdownModule,
		...COMPONENTS
	],
	exports: [
		...COMPONENTS
	],
	providers: [
	]
})
export class CoreModule { }
